import React, { useContext, useEffect, useRef } from 'react';
import Row from 'components/Common/Row';
import Typography from 'kingpin/atoms/Typography';
import Card from 'components/Common/Card';
import ScorecardContext from 'contexts/ScorecardContext';
import GridTargets from './GridTargets';
import { Col } from './styles';

const KpiGrid = ({
  kpi,
  trend,
  metric,
  slideoutPeriod,
}: {
  kpi: Scorecards.ScorecardKpi | Scorecards.ManualKpiRow;
  trend: Goals.TrendResult[];
  metric?: Metrics.Metric;
  slideoutPeriod: Period;
}) => {
  const { selectedPeriods } = useContext(ScorecardContext);
  const selectedRowRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (
      selectedRowRef &&
      !!selectedRowRef.current &&
      !!selectedRowRef.current.scrollIntoView
    ) {
      selectedRowRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'nearest',
      });
    }
  }, [kpi, slideoutPeriod]);

  return (
    <div data-testid={'grid-preview'}>
      <Card>
        <Row
          centerAlign
          style={{
            padding: '8px',
            boxShadow: 'var(--shadow-inset)',
            position: 'sticky',
            top: 0,
            backgroundColor: 'var(--color-bg-primary)',
            minWidth: 'fit-content',
          }}
        >
          <Col>
            <Typography.Body type="Body 12">Period</Typography.Body>
          </Col>

          <Col>
            <Typography.Body type="Body 12">Target</Typography.Body>
          </Col>
          <Col>
            <Typography.Body type="Body 12">Actual</Typography.Body>
          </Col>
          <Col isWide>
            <Typography.Body type="Body 12">Diff</Typography.Body>
          </Col>
        </Row>
        <div
          style={{
            maxHeight: '208px',
            overflowY: 'scroll',
          }}
        >
          {[...selectedPeriods].reverse().map((p) => (
            <Row
              ref={p === slideoutPeriod ? selectedRowRef : null}
              key={p.startDate}
              centerAlign
              style={{
                backgroundColor:
                  p === slideoutPeriod ? 'var(--color-bg-selected)' : undefined,
                boxShadow: 'var(--shadow-inset)',
                padding: '8px',
                minHeight: 32,
                minWidth: 'fit-content',
              }}
            >
              <GridTargets kpi={kpi} trend={trend} metric={metric} period={p} />
            </Row>
          ))}
        </div>
      </Card>
    </div>
  );
};

export default KpiGrid;
